import { apiConfig } from '../api-config';

export interface CreateVoucherBody {
  tokenKey: string;
  nameProducer: string;
  document: string;
  expirationDate: string;
  cdUser: number;
}

export const createVoucher = (data: CreateVoucherBody) => apiConfig
  .post('api/Voucher', data)
  .then((response) => response.data)
  .catch((error) => ({ error, hasError: true }));
